import api from "./Api";

class TipoProdutoService {
  GetTipoProduto(payload) {
    return api.get("/v1/tipoProduto/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTipoProduto(payload) {
    return api.post("/v1/tipoProduto/", payload).then((response) => {
      return response.data;
    });
  }

  PutTipoProduto(payload) {
    return api.put("/v1/tipoProduto/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTipoProduto(payload) {
    return api.delete("/v1/tipoProduto/" + payload).then((response) => {
      return response.data;
    });
  }

  GetTipoProdutoOData(payload) {
    return api.get("/OData/TipoProduto" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new TipoProdutoService();
